import asyncActionTypes from '../actions/types';

const initialState = {
  GdocumentNumbers: [],
  sendInfoToSalesForce: false,
};

const refundGticketList = (
  state = initialState,
  action = null / undefined
) => {
  switch (action.type) {
    case asyncActionTypes.UPDATE_G_DOCUMENT_NUMBERS.START:
      return {
        GdocumentNumbers: initialState.documentNumbers,
      };
    case asyncActionTypes.UPDATE_G_DOCUMENT_NUMBERS.SUCCESS:
      return {
        GdocumentNumbers: action?.payload,
        sendInfoToSalesForce: true,
      };
    case asyncActionTypes.UPDATE_G_DOCUMENT_NUMBERS.FAIL:
      return {
        GdocumentNumbers: initialState.documentNumbers,
      };
    default:
      return state;
  }
};

export default refundGticketList;
